import React from "react";
import { Alert, Grid } from "@mui/material";

type Props = {
  isShow: boolean;
};

const ReplacementNotice = ({ isShow }: Props) =>
  isShow ? (
    <Grid item xs={12}>
      <Alert severity="warning">
        You have pending action(s) to proceed with your laptop replacement.
      </Alert>
    </Grid>
  ) : null;

export default ReplacementNotice;
